// Services.jsx
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AzyByteTechLanding.css';
import Navbar from './Navbar';
import Footer from './Footer';
import wordpressimg from '../assets/services_wordpress.png';
import shopifyimg from '../assets/services_shopify.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect} from 'react';
import { Helmet } from 'react-helmet-async';


function Services() {

   useEffect(() => {
      AOS.init({
        duration: 1000, // Animation duration in ms
        once: true,     // Whether animation should happen only once - while scrolling down
        offset: 100,    // Offset (in px) from the original trigger point
      });
    }, []);

  return (
    <div>
      <Helmet>
        <title>
          Services | AzyByte Technologies - Web Development, AI & Software Solutions
        </title>

        <meta
          name="description"
          content="Explore AzyByte Technologies services including web development, custom software solutions, AI automation, mobile applications, cloud solutions, WordPress development, and Shopify stores."
        />

        <meta
          name="keywords"
          content="AzyByte Technologies Services, AzyByte , Web Development Services Nadiad, Software Development Company Nadiad, AI Automation Services, Mobile App Development, WordPress Development, Shopify Development"
        />

        <link
          rel="canonical"
          href="https://www.azybyte.in/services"
        />

        <meta
          property="og:title"
          content="AzyByte Technologies Services"
        />

        <meta
          property="og:description"
          content="Professional web development, software engineering, AI automation, mobile app development, and cloud solutions."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://www.azybyte.in/services"
        />

        <meta
          property="og:image"
          content="https://www.azybyte.in/azybytelogo.png"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: "Software Development Services",
            provider: {
              "@type": "Organization",
              name: "AzyByte Technologies",
              url: "https://www.azybyte.in"
            },
            areaServed: {
              "@type": "Country",
              name: "India"
            },
            description:
              "Web development, mobile app development, AI automation, cloud solutions, Shopify and WordPress development services."
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "AzyByte Technologies",
            url: "https://www.azybyte.in",
            logo: "https://www.azybyte.in/azybytelogo.png",
            sameAs: [
              "https://www.linkedin.com/company/azybytetechnologies",
              "https://instagram.com/azybytetech"
            ]
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What services does AzyByte Technologies provide?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We provide web development, software development, AI automation, mobile app development, WordPress, Shopify, and cloud solutions."
                }
              },
              {
                "@type": "Question",
                name: "Do you offer custom software development?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, we build custom software solutions tailored to business requirements."
                }
              },
              {
                "@type": "Question",
                name: "What is your pricing structure?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We offer flexible pricing models including fixed-price projects, hourly rates, and retainer arrangements. The best model depends on your project's requirements and scope."
                }
              },
            ]
          })}
        </script>
      </Helmet>
      {/* Navbar */}
      <Navbar></Navbar>
      {/* Page Header */}
      <section className="bg-light py-5 mt-5">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h1 className="fw-bold mb-3">Our Services at AzyByte Technologies</h1>
              <p className="lead mb-0">
                We provide comprehensive technology solutions tailored to help your business
                thrive in today's competitive digital landscape.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Services Section */}
      <section className="py-5">
        <div className="container py-4">

          <div className="row mb-5" id='webdev'>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-right">
                <div className="feature-icon mb-3">
                  <i className="bi bi-code-square text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">Web Development</h3>
                <p className="mb-3">
                  Our expert team creates custom web applications and responsive websites
                  tailored to your unique business requirements. Whether you need a simple
                  informational site or a complex web application, we have the expertise to deliver.
                </p>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Responsive website design and development
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Custom web application development
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    E-commerce solutions
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    CMS integration and development
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6" data-aos="flip-left">
              <img
                src="https://images.pexels.com/photos/16675632/pexels-photo-16675632.jpeg"
                alt="AzyByte Technologies Web Development"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>

          <div className="row mb-5 flex-lg-row-reverse" id='wordpressdev'>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-left">
                <div className="feature-icon mb-3">
                  <i className="bi bi-phone text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">Wordpress Website Development</h3>
               <p className="mb-3">
                  We build powerful, scalable, and easy-to-manage websites using WordPress.
                  Whether you need a business website, blog, or custom solution, we deliver
                  high-performance websites with modern design and full flexibility.
                </p>

                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Custom WordPress website development
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Theme customization and plugin integration
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    SEO-friendly and fast-loading websites
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Website maintenance and security updates
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6" data-aos="flip-right">
              <img
                src={wordpressimg}
                alt="AzyByte Technologies Wordpress Website Development"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-right">
                <div className="feature-icon mb-3">
                  <i className="bi bi-phone text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">Shopify Website Development</h3>
                <p className="mb-3">
                  We create high-converting Shopify stores designed to boost your online sales.
                  From store setup to customization, we provide complete e-commerce solutions
                  tailored to your business goals.
                </p>

                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Shopify store setup and configuration
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Custom Shopify theme design
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Payment gateway and app integration
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Store optimization for conversions and speed
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6"  data-aos="flip-left">
              <img
                src={shopifyimg}
                alt="AzyByte Technologies Shopify Webiste Development"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>

          <div className="row mb-5 flex-lg-row-reverse" id='appdev'>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-left">
                <div className="feature-icon mb-3">
                  <i className="bi bi-phone text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">Mobile App Development</h3>
                <p className="mb-3">
                  We develop high-performance, user-friendly mobile applications for iOS and
                  Android platforms that help businesses connect with their customers on the go.
                  Our mobile solutions are built with the latest technologies and best practices.
                </p>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Native iOS and Android app development
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Cross-platform app development
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Mobile app UI/UX design
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    App maintenance and support
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6"  data-aos="flip-right">
              <img
                src="https://images.pexels.com/photos/14158915/pexels-photo-14158915.jpeg"
                alt="AzyByte Technologies Mobile App Development"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>

          {/* //chatbot */}
          <div className="row mb-5 " id='chatbots'>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-left">
                <div className="feature-icon mb-3">
                  <i className="bi bi-phone text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">AI chatbots and Automations</h3>
                <p className="mb-3">
                  We build intelligent AI chatbots and automation systems that help businesses
                  automate customer support, generate leads, handle inquiries, and improve
                  operational efficiency. Our solutions integrate seamlessly with websites,
                  WhatsApp, and business workflows to deliver smart, scalable experiences.
                </p>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    AI-powered customer support chatbots
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    WhatsApp automation & intelligent workflows
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Custom AI agents using LangChain & LLMs
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    CRM, lead generation & business process automation
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6"  data-aos="flip-right">
              <img
                src="https://st5.depositphotos.com/3900811/64992/i/450/depositphotos_649928030-stock-photo-chatbot-assistant-automated-customer-support.jpg"
                alt="AzyByte Technologies Mobile App Development"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>

          <div className="row mb-5 flex-lg-row-reverse" id='cloudsol'>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-right">
                <div className="feature-icon mb-3">
                  <i className="bi bi-cloud text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">Cloud Solutions</h3>
               <p className="mb-3">
                  We help businesses leverage cloud technologies to improve scalability,
                  security, and performance. Our cloud solutions are designed to optimize
                  your operations and reduce infrastructure costs.
                </p>

                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Cloud architecture design and deployment
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Cloud migration and modernization
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    AWS, Azure, and Google Cloud solutions
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Cloud monitoring, security, and support
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6" data-aos="flip-left">
              <img
                src="https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg"
                alt="AzyByte Technologies Cloud Solutions"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>

          <div className="row mb-5 " id='uiux'>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-left">
                <div className="feature-icon mb-3">
                  <i className="bi bi-palette text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">UI/UX Design</h3>
                <p className="mb-3">
                  We create intuitive, user-friendly interfaces that enhance user experience and
                  drive engagement. Our design process focuses on understanding your users' needs
                  and creating interfaces that are both beautiful and functional.
                </p>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    User research and personas
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Wireframing and prototyping
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Visual design and branding
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Usability testing and optimization
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6"  data-aos="flip-right">
              <img
                src="https://images.pexels.com/photos/17771099/pexels-photo-17771099.jpeg"
                alt="AzyByte Technologies UI/UX Design"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>

          <div className="row flex-lg-row-reverse" id='itconsultancy'>
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-4" data-aos="slide-right">
                <div className="feature-icon mb-3">
                  <i className="bi bi-people text-primary"></i>
                </div>
                <h3 className="fw-bold mb-3">IT Consultancy(free)</h3>
                <p className="mb-3">
                  We provide expert IT consulting services to help businesses make smarter
                  technology decisions. Our strategies are focused on growth, efficiency,
                  and long-term success.
                </p>

                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    IT strategy and planning
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Digital transformation consulting
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Infrastructure and system analysis
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill text-primary me-2"></i>
                    Technology consulting and support
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6"  data-aos="flip-left">
              <img
                src="https://images.pexels.com/photos/36765718/pexels-photo-36765718.jpeg"
                alt="AzyByte Technologies IT Consultancy"
                className="img-fluid rounded shadow-sm"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="fw-bold mb-3">Ready to Elevate Your Business?</h2>
              <p className="lead mb-4">
                Let's work together to create technology solutions that will transform your business
                and drive growth. Contact us today to get started.
              </p>
              <a href="/contact" className="btn btn-primary btn-lg px-5">Get in Touch</a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
     <Footer></Footer>
    </div>
  );
}

export default Services;